import styled from "@emotion/styled";

export const FormSection = styled.div`
  flex: 3;
  width: 100%;
`;

export const UploadSection = styled.div`
  flex: 2;
  width: 100%;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const ErrorBox = styled.div`
  background-color: #fff3f3;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
`;

export const ErrorTitle = styled.strong`
  color: #d32f2f;
`;

export const ErrorList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 20px;
`;
